<template>
  <div
    class="inline row items-center q-px-xs q-py-sm cursor-pointer rounded-borders-lg"
    v-bind="$attrs"
    v-on="$listeners"
    style="left: -8px;"
  >
    <QIcon class="q-mr-xs" :color="color" :name="icon" :size="iconSize" />
    <span :class="`text-${color} text-${labelSize} text-weight-medium`">
      {{ label }}
    </span>
  </div>
</template>

<script>
import { QIcon } from 'quasar';

export default {
  name: 'BtnBack',
  props: {
    icon: {
      type: String,
      default: 'eva-arrow-back'
    },
    color: {
      type: String,
      default: 'grey-8'
    },
    label: {
      type: String,
      default: 'Back'
    },
    iconSize: {
      type: String,
      default: '20px'
    },
    labelSize: {
      type: String,
      default: 'paragraph'
    }
  },
  components: {
    QIcon
  }
};
</script>
